/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RdsSnapshot { 
    /**
     * DB Snapshot name
     */
    snapshot_name: string;
    /**
     * Cluster Name
     */
    cluster_name: string;
    /**
     * DB Snapshot type
     */
    snapshot_type: string;
    /**
     * Created timestamp in UTC
     */
    created_timestamp: Date;
}

